export function isScopeSelector(property) {
    return property.substring(0, 6) === '@scope';
}
//# sourceMappingURL=isScopeSelector.js.map